export const getters = {
  getOrgs: (state) => {
    return state.orgs
  },
  getSelected: (state) => {
    return state.selectedOrg
  },
  getSelectedOrg: (state) => {
    return state.orgs.find(o => o.organization_id === parseInt(state.selectedOrg))
  },
  getCurrent: (state) => {
    return state.current
  },
  getCurrentMembers: (state) => {
    return state.currentMembers
  },
  getCurrentInvites: (state) => {
    return state.currentInvites
  },
  getPendingInvites: (state) => {
    return state.pendingInvites
  },
  getApikeys: (state) => {
    return state.apikeys
  }
}
